import { httpCreate } from './http';
import env from '../services/config.js';

const http = httpCreate('');

const host = env.key == 'v1' ? 'https://crm.ourwill.cn' : 'https://crmdev.ourwill.cn';

export const worker = {
	// 获取客服二维码
	getWorkerQrcode() {
		return http.get(`${host}/api/worker/qrCode?roleId=2`);
	},
};
